// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ht-j","productName":"Table_productName__15c9I"};